import { render, staticRenderFns } from "./CompressProportionIcon.vue?vue&type=template&id=e0a8284e&"
import script from "./CompressProportionIcon.vue?vue&type=script&lang=js&"
export * from "./CompressProportionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports